import * as yup from 'yup';
import { Code } from "./Code";

export class ProductAttribute {
    Id: string;
    AttributeId: string;
    ProductId: string;
    EmersonProductId?: string;    
    SortOrder: number;
    ShortDescription: string;
    LongDescription: string;
    PrimarySearch: boolean;
    AdvancedSearch: boolean;
    ProductDetails: boolean;
    AttributeType: string;
    Name: string;
    Codes: Code[];
    _usedFor: string;

    constructor() {
        this.Id = '';
        this.AttributeId = '';
        this.ProductId = '';
        this.EmersonProductId = '';
        this.ShortDescription = '';
        this.LongDescription = '';
        this.PrimarySearch = false;
        this.AdvancedSearch = false;
        this.ProductDetails = false;
        this.AttributeType = '';
        this.Name = '';
        this._usedFor = '';
    }

    public static mapToFieldUsedFor(item: ProductAttribute) {

        if (item.PrimarySearch === true)
            item._usedFor = 'PrimarySearch';

        if (item.AdvancedSearch === true)
            item._usedFor = 'AdvancedSearch';

        if (item.ProductDetails === true)
            item._usedFor = 'ProductDetails';
    }

    public static mapFromFieldUsedFor(item: ProductAttribute) {

        item.PrimarySearch = item._usedFor === 'PrimarySearch';
        item.AdvancedSearch = item._usedFor === 'AdvancedSearch';
        item.ProductDetails = item._usedFor === 'ProductDetails';
    }    
}

/*export class ProductAttributeView extends ProductAttribute{
//   Description: string;
    codes: Code[];
}*/


export const ProductAttributeValidationSchema = yup.object().shape({
    ShortDescription: yup.string().required('Required')
//    AttributeId: yup.number().min(1, 'Required')
});

